import React, { useContext } from 'react';
import DeviceManager, { DeviceManagerContext, } from '@trainline-shareable/device-manager';
import Depot from '../../../_shared/depot';
import ModalFilterButton from './ModalFilterButton';
import BubbleFilterButton from './BubbleFilterButton';
const MenuFilterButtonWithoutRef = ({ bubbleProps, modalProps, ...commonProps }) => {
    // Device Manager
    const deviceManager = useContext(DeviceManagerContext);
    const isMobileViewport = /(X?S)/.test((deviceManager === null || deviceManager === void 0 ? void 0 : deviceManager.viewPort) || 'S');
    if (isMobileViewport) {
        return React.createElement(ModalFilterButton, { modalProps: modalProps, ...commonProps });
    }
    return React.createElement(BubbleFilterButton, { bubbleProps: bubbleProps, ...commonProps });
};
const MenuFilterButtonWithWrappers = (props) => (React.createElement(DeviceManager, null,
    React.createElement(MenuFilterButtonWithoutRef, { ...props })));
const MenuFilterButton = Depot.withRef(MenuFilterButtonWithWrappers);
MenuFilterButton.displayName = 'MenuFilterButton';
export default MenuFilterButton;
//# sourceMappingURL=index.js.map